import { testimonials } from "@/mocks/comics";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function About() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫漫画网",
    url: "https://hanman.cn/",
    description: "无遮韩国免费漫画大全 - 免费在线阅读韩漫，漫画爱好者聚集的理想之地。",
    foundingDate: "2020",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      email: "contact@hanman.cn",
      availableLanguage: ["Chinese"],
    },
  };

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 韩漫漫画网",
    description: "韩漫漫画网品牌介绍、口碑评价与联系方式",
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <main className="min-h-screen bg-background-50 pt-16">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            { label: "关于我们" },
          ]}
        />

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-10" aria-label="品牌介绍">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            关于韩漫漫画网
          </h1>
          <p className="text-sm text-foreground-500 mb-8">无遮韩国免费漫画大全 · 漫画爱好者的理想之地</p>

          <div className="flex flex-col lg:flex-row gap-8 items-start mb-12">
            <div className="flex-1">
              <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">品牌故事</h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                韩漫漫画网成立于2020年，由一群热爱韩国漫画的年轻人共同创建。我们的初心很简单——让每一位漫画爱好者都能便捷、免费地享受到高品质的韩国漫画阅读体验。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                五年来，我们从最初的几十部漫画资源发展到如今拥有超过<strong>10,000部</strong>韩漫作品的规模，涵盖了
                恋爱、奇幻、动作、悬疑、搞笑、恐怖、校园、都市等多种类型，满足不同读者的喜好。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们始终坚持<strong>免费阅读</strong>的原则，致力于打破语言和地域的壁垒，
                让中文读者能够第一时间看到最新、最热的韩国漫画。我们的团队由专业的漫画编辑、翻译人员和
                技术工程师组成，每天为读者精选优质内容。
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-80 aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%20of%20cozy%20reading%20space%20with%20bookshelves%20and%20warm%20lighting%2C%20soft%20cream%20and%20warm%20beige%20color%20palette%2C%20minimalist%20Korean%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=hanman-about-01&orientation=landscape"
                alt="韩漫漫画网品牌形象"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
            {[
              { value: "10,000+", label: "漫画资源" },
              { value: "500万+", label: "忠实读者" },
              { value: "每日更新", label: "同步韩国" },
              { value: "5年", label: "行业深耕" },
            ].map((stat) => (
              <div key={stat.label} className="bg-background-100 rounded-lg p-5 text-center">
                <p className="font-heading text-2xl font-bold text-primary-500">{stat.value}</p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>

          <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-4">我们的优势</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
            {[
              {
                icon: "ri-shield-check-line",
                title: "正版授权",
                desc: "与韩国多家漫画平台合作，确保内容合法合规，让读者看得放心。",
              },
              {
                icon: "ri-flashlight-line",
                title: "极速更新",
                desc: "热门漫画与韩国同步更新，每周稳定更新，追漫不再等待。",
              },
              {
                icon: "ri-hd-line",
                title: "高清画质",
                desc: "所有漫画均提供高清版本，支持缩放查看细节，带来沉浸式阅读体验。",
              },
              {
                icon: "ri-smartphone-line",
                title: "多端适配",
                desc: "电脑、平板、手机全平台支持，随时随地畅享韩漫阅读乐趣。",
              },
            ].map((item) => (
              <div key={item.title} className="flex gap-4 p-5 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-primary-100 rounded-lg">
                  <i className={`${item.icon} text-lg text-primary-500`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100 py-10 md:py-14" aria-label="读者口碑">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">读者口碑</h2>
              <p className="text-sm text-foreground-500 mt-2">来自真实读者的评价</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: t.rating }).map((_, i) => (
                          <div key={i} className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-star-fill text-accent-500 text-xs"></i>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.comment}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-10" id="contact" aria-label="联系方式">
          <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-6">联系我们</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-lg p-5 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center bg-primary-100 rounded-lg mb-3">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
              <p className="text-xs text-foreground-500">contact@hanman.cn</p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                <i className="ri-customer-service-2-line text-lg text-accent-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">客服热线</h3>
              <p className="text-xs text-foreground-500">400-888-0000</p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 text-center">
              <div className="w-10 h-10 mx-auto flex items-center justify-center bg-secondary-100 rounded-lg mb-3">
                <i className="ri-time-line text-lg text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">工作时间</h3>
              <p className="text-xs text-foreground-500">周一至周五 9:00-18:00</p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}